import Firebase from '../../../lib/Firebase';
import Firestore from '../../../lib/Firestore';

export default {
  all(city) {
    return Firebase.firestore()
      .collection('cities')
      .doc(city.docId)
      .collection('delivery-boys')
      .get()
      .then(docs => {
        return Firestore.getCollectionData(docs);
      });
  },

  manage(id, city, name, contact, imageUrl = null) {
    const deliveryBoyObj = {
      name,
      contact,
      imageUrl
    };

    const promise = id
      ? Firebase.firestore()
          .collection('cities')
          .doc(city.docId)
          .collection('delivery-boys')
          .doc(id)
          .update(deliveryBoyObj)
      : Firebase.firestore()
          .collection('cities')
          .doc(city.docId)
          .collection('delivery-boys')
          .add(deliveryBoyObj);

    return promise;
  },

  deleteBoy(city, option) {
    return Firebase.firestore()
      .collection('cities')
      .doc(city.docId)
      .collection('delivery-boys')
      .doc(option.docId)
      .delete();
  }
};



// WEBPACK FOOTER //
// ./src/pages/cities/DeliveryBoys/service.js